export const YTDPerformanceTable = {
  title: 'Iam Defined Benefit: YTD Performance by Index ',
  columns: [
    'No',
    'Fund',
    'Index ID',
    'Inception',
    'Strategy',
    'Performance (%)',
    'Standard Deviation (%)',
    'Sharpe Ratio',
    'Oct-07',
    'Nov-07',
    'Dec-07',
  ],
  rows: [
    {
      no: 1,
      fund: 'HFR Weighted Comp',
      indexId: 58,
      inception: 'Jan 70',
      strategy: 'Absolute Return',
      performance: 9.96,
      standardDeviation: 5.25,
      sharpeRatio: 1.02,
      monthlyPerformance: {
        'Oct-07': 2.85,
        'Nov-07': -2.2,
        'Dec-07': 0.53,
      },
    },
    {
      no: 2,
      fund: 'Lehman Global Agg TR Value Hedged Index',
      indexId: 204,
      inception: 'Jan 70',
      strategy: 'Fixed Income Long Only',
      performance: 5.39,
      standardDeviation: 2.24,
      sharpeRatio: 0.42,
      monthlyPerformance: {
        'Oct-07': 0.85,
        'Nov-07': 1.15,
        'Dec-07': 0.21,
      },
    },
    {
      no: 3,
      fund: 'URS Composite Benchmark',
      indexId: 249,
      inception: 'Dec 67',
      strategy: 'Pension',
      performance: 9.06,
      standardDeviation: 4.82,
      sharpeRatio: 0.93,
      monthlyPerformance: {
        'Oct-07': 1.96,
        'Nov-07': -1.76,
        'Dec-07': -0.25,
      },
    },
    {
      no: 4,
      fund: 'S&P Priv Eq Index',
      indexId: 709,
      inception: 'Jan 04',
      strategy: 'Private Equity',
      performance: -13.78,
      standardDeviation: 15.13,
      sharpeRatio: -1.15,
      monthlyPerformance: {
        'Oct-07': 4.1,
        'Nov-07': -9.42,
        'Dec-07': -6.45,
      },
    },
    {
      no: 5,
      fund: 'MSCI AC World TR Net Div USD Index',
      indexId: 205,
      inception: 'Jan 70',
      strategy: 'Public Equity',
      performance: 11.66,
      standardDeviation: 9.91,
      sharpeRatio: 0.7,
      monthlyPerformance: {
        'Oct-07': 3.9,
        'Nov-07': -4.42,
        'Dec-07': -1.11,
      },
    },
    {
      no: 6,
      fund: 'NCREIF Real State Index',
      indexId: 244,
      inception: 'Jan 78',
      strategy: 'Real Estate',
      performance: 27.77,
      standardDeviation: 4.44,
      sharpeRatio: 5.06,
      monthlyPerformance: {
        'Oct-07': 1.06,
        'Nov-07': 1.06,
        'Dec-07': 3.21,
      },
    },
  ],
};

export const IAMDefinedBenefitTable = {
  title:
    'Iam Defined Benefit: YTD Performance',
  columns: [
    'No',
    'Fund',
    'Allocation (%)',
    'Inception',
    'Strategy',
    'Performance (%)',
    'Standard Deviation (%)',
    'Sharpe Ratio',
    'Oct-07',
    'Nov-07',
    'Dec-07',
  ],
  rows: [
    {
      no: 1,
      fund: 'IAM Absolute Return',
      allocation: 10.73,
      inception: 'Jan 06',
      strategy: 'Absolute Return',
      performance: -0.69,
      standardDeviation: 5.67,
      sharpeRatio: -0.86,
      monthlyPerformance: {
        'Oct-07': 1.53,
        'Nov-07': -1.85,
        'Dec-07': -0.01,
      },
    },
    {
      no: 2,
      fund: 'IAM Fixed Income',
      allocation: 24.62,
      inception: 'Jan 88',
      strategy: 'Fixed Income Long Only',
      performance: 6.75,
      standardDeviation: 2.77,
      sharpeRatio: 0.81,
      monthlyPerformance: {
        'Oct-07': 1.06,
        'Nov-07': 1.14,
        'Dec-07': 0.09,
      },
    },
    {
      no: 3,
      fund: 'IAM Private Equity',
      allocation: 5.5,
      inception: 'Jan 88',
      strategy: 'Private Equity',
      performance: 23.73,
      standardDeviation: 4.55,
      sharpeRatio: 4.09,
      monthlyPerformance: {
        'Oct-07': 0.59,
        'Nov-07': 0.72,
        'Dec-07': 0.7,
      },
    },
    {
      no: 4,
      fund: 'IAM International Equity',
      allocation: 19.18,
      inception: 'Jan 88',
      strategy: 'Public Equity',
      performance: 9.76,
      standardDeviation: 9.63,
      sharpeRatio: 0.54,
      monthlyPerformance: {
        'Oct-07': 4.11,
        'Nov-07': -4.78,
        'Dec-07': -1.41,
      },
    },
    {
      no: 5,
      fund: 'IAM Domestic Equity',
      allocation: 33.73,
      inception: 'Jan 88',
      strategy: 'Public Equity',
      performance: 3.19,
      standardDeviation: 10.32,
      sharpeRatio: -0.11,
      monthlyPerformance: {
        'Oct-07': 2.06,
        'Nov-07': -5.32,
        'Dec-07': -0.8,
      },
    },
    {
      no: 6,
      fund: 'IAM Real Estate',
      allocation: 10.99,
      inception: 'Jan 88',
      strategy: 'Real Estate',
      performance: 14.98,
      standardDeviation: 11.93,
      sharpeRatio: 0.85,
      monthlyPerformance: {
        'Oct-07': 0.46,
        'Nov-07': -1.28,
        'Dec-07': 7.97,
      },
    },
    {
      no: null,
      fund: 'IAM Defined Benefit',
      allocation: 104.76,
      inception: 'Jan 88',
      strategy: 'Pension',
      performance: 8.17,
      standardDeviation: 6.24,
      sharpeRatio: 0.58,
      monthlyPerformance: {
        'Oct-07': 2.14,
        'Nov-07': -2.74,
        'Dec-07': 0.47,
      },
    },
  ],
};
